module.exports = {
    User: 'user',
    Admin: 'admin',
    Preapprover: 'preapprover',
    Approver: 'approver',
    Reader: 'reader'
}